import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { SIGNUP_COLORS } from "../../../pages/public/SignUp/tokens";

export interface StepIndicatorProps {
  number: number;
  label: string;
  active: boolean;
  completed: boolean;
  onClick?: () => void;
  isLast?: boolean;
  gapPx?: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  number,
  label,
  active,
  completed,
  onClick,
  isLast = false,
  gapPx = 24,
}) => {
  const numberStyles =
    active || completed
      ? {
          backgroundColor: SIGNUP_COLORS.white,
          color: SIGNUP_COLORS.primary,
          border: `2px solid ${SIGNUP_COLORS.white}`,
        }
      : {
          backgroundColor: "transparent",
          color: "#98A2B3",
          border: "2px solid #98A2B3",
        };

  const labelStyles = active
    ? { color: SIGNUP_COLORS.white, fontWeight: 700, opacity: 1 }
    : completed
    ? { color: SIGNUP_COLORS.white, fontWeight: 600, opacity: 0.95 }
    : { color: SIGNUP_COLORS.white, fontWeight: 500, opacity: 0.6 };

  const connectorColor = completed ? SIGNUP_COLORS.white : "#98A2B3";
  const connectorOpacity = completed ? 1 : 0.5;

  return (
    <Box sx={{ position: "relative" }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          cursor: completed || active ? "pointer" : "default",
          "&:hover": { opacity: completed || active ? 0.9 : 1 },
        }}
        onClick={completed || active ? onClick : undefined}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            ...numberStyles,
          }}
        >
          <Typography
            fontFamily="Manrope"
            fontSize="12px"
            fontWeight={700}
            lineHeight="16px"
            sx={{ transform: "translateY(-0.5px)" }}
          >
            {number}
          </Typography>
        </Box>

        <Typography
          fontFamily="Manrope"
          fontSize="16px"
          lineHeight="24px"
          sx={{ ...labelStyles, transition: "color .2s ease, opacity .2s ease" }}
        >
          {label}
        </Typography>
      </Stack>

      {!isLast && (
        <Box
          sx={{
            position: "absolute",
            left: 12,
            top: 24,
            width: 2,
            height: `${gapPx}px`,
            bgcolor: connectorColor,
            opacity: connectorOpacity,
          }}
        />
      )}
    </Box>
  );
};

export default StepIndicator;
